module.exports = __webpack_public_path__ + "2e39fa2afa20992885987c1c30948e60.fbx";